
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#400F3F","rx":"16"}}),_c('path',{attrs:{"fill":"#FF4702","d":"M84.91 36.5H39.09A5.11 5.11 0 0034 41.6v30.6a5.11 5.11 0 005.09 5.1h17.82v5.1h-2.546a2.548 2.548 0 00-2.546 2.55c0 1.408 1.14 2.55 2.546 2.55h15.272a2.548 2.548 0 002.546-2.55c0-1.408-1.14-2.55-2.546-2.55h-2.545v-5.1h17.818A5.11 5.11 0 0090 72.2V41.6a5.11 5.11 0 00-5.09-5.1zm-2.546 35.7H41.636a2.548 2.548 0 01-2.545-2.55v-25.5c0-1.408 1.14-2.55 2.545-2.55h40.728a2.548 2.548 0 012.545 2.55v25.5c0 1.408-1.14 2.55-2.545 2.55z"}})])])
          )
        }
      }
    